import { Navbar } from "@/components/Navbar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import { Bento } from "@/sections/Bento";

export default function LifestyleTraining() {
  return (
    <main data-testid="lifestyle-training-page" className="pt-10">
      <Navbar />
      <CartDrawer />
      <Bento />
      <Footer />
    </main>
  );
}
